import { GetServerSideProps } from 'next';
import React from 'react';
import HomeComponent from '../components/Home/HomeComponent';
import Layout from '../components/Layout/Layout';
import { apiRequest } from '../components/util/requests/requests';
import { getWorksAndResources } from '../components/util/requests/homepageContent';
import { PageMetadata } from '../components/util/SeoMetaInformationComponent/SeoMetaInformationComponent';
import { Resource } from './resources';

export interface HomeProps {
    works: Array<Work>;
    resources: Array<Resource>;
    pageMetadata?: PageMetadata;
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    const { works, resources } = await getWorksAndResources();

    const pageMetadata = await apiRequest('/meta-pages?filters[key]=HOME_PAGE&populate[0]=seo');

    return {
        props: {
            works,
            resources,
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
        },
    };
};

const Home = ({ works, resources, pageMetadata }: HomeProps) => {
    return (
        <Layout seoMetadata={pageMetadata?.seo}>
            <HomeComponent works={works} resources={resources} />
        </Layout>
    );
};

export default Home;
